import React from 'react'
import packageJson from '../../package.json'

interface FooterProps {
  className?: string
}

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const version = packageJson.version

  return (
    <footer className={`fixed bottom-0 left-0 right-0 bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 text-xs py-2 px-4 border-t border-gray-200 dark:border-gray-700 z-10 ${className}`}>
      <div className="text-center">
        Ask-Ed v{version}
      </div>
    </footer>
  )
}

export default Footer
